import { render, staticRenderFns } from "./HistogramPictures.vue?vue&type=template&id=5241c19f&scoped=true"
import script from "./HistogramPictures.vue?vue&type=script&lang=js"
export * from "./HistogramPictures.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5241c19f",
  null
  
)

export default component.exports